import React, { useState } from 'react'
import { useMerchant, readCustomer, readPaymentRequestMerchant, readCardPayout } from "@auth";
import { customersModule } from "@auth/modules";
import { createNotificationChannel } from "@api/merchantsController";
import { Modal, Button } from "@components";
import { toast } from "@components/toast/Toast";
import MailboxForm from "../forms/MailboxForm"
import { useForm } from 'react-hook-form';

const AddSharedMailbox = ({open, onClose, onComplete, branches}) => {

  const { hasModule, hasPermission } = useMerchant();
  const [loading, setLoading] = useState(false)

  const { control, setValue, watch, handleSubmit, formState: { errors, isValid }, reset, clearErrors } = useForm({
    defaultValues: {
      name: "",
      email: "",
      branchId: "",
      AllPayments: false,
      CustomerPayments: false,
      Payouts: false,
      TerminalPayments: false,
    }
  });

  const allPaymentsIsTrue = watch("AllPayments")

  const addMailbox = async (values) => {
    const subs = [];
    if (values.AllPayments) subs.push("AllPayments");
    if (values.CustomerPayments) subs.push("CustomerPayments");
    if (values.Payouts) subs.push("Payouts");
    if (values.TerminalPayments) subs.push("TerminalPayments");
 
    await createNotificationChannel(
      values.name.trim(),
      values.email.trim(),
      values.branchId ? values.branchId : null,
      subs
    );
  }

  const onSubmit = async (values) => {
    setLoading(true);
    await addMailbox(values);
    setLoading(false);

    toast({ description: `Created "${values.name}" shared mailbox` });
    onComplete();
    handleClose();
  };

  const handleClose = () => {
    reset()
    clearErrors()
    onClose()
  }

  const onSubChange = (name, value) => {
    if (name === "AllPayments" && value) {
      setValue("CustomerPayments", false);
    }
    if (name === "Payouts" && value) {
      setValue("branchId", "");
    }
  }

  const onBranchChange = (value) => {
    if (value !== "") {
      setValue("Payouts", false);
    }
  }

  return (
    <Modal isOpen={open} onClose={handleClose} title="Add shared mailbox" size="sm">
      <MailboxForm
        control={control}
        handleSubmit={handleSubmit}
        onSubmit ={onSubmit}
        errors ={errors}
        onSubChange={onSubChange}
        hasPermission ={hasPermission}
        hasModule ={hasModule}
        readPaymentRequestMerchant ={readPaymentRequestMerchant}
        customersModule ={customersModule}
        readCustomer ={readCustomer}
        readCardPayout ={readCardPayout}
        allPaymentsIsTrue={allPaymentsIsTrue}
        branches={branches}
        onBranchChange={onBranchChange}
      />
      <div className="p-4 flex gap-2 justify-end border-t">
        <Button onClick={handleClose} disabled={loading} color="secondary">Cancel</Button>
        <Button 
          type="submit" 
          onClick={handleSubmit(onSubmit)} 
          color="primary" 
          disabled={!isValid}
          submitting={loading}
        >Create mailbox</Button>
      </div>
    </Modal>
  )
}

export default AddSharedMailbox